<div class="mdl-grid">
  <div class="mdl-cell mdl-cell--12-col">
    <h1>404 Not found</h1>
    <h3>You were linked to a page or resource that doesn't exist anymore.</h3>
    <h4><a [routerLink]="['/']">Go home</a></h4>
  </div>
</div>
<vs-footer></vs-footer>
